import { toast } from 'react-toastify';

// Toast configuration
const toastConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};

// Success toast (green)
export const showSuccess = (message) => {
    toast.success(message, {
        ...toastConfig,
        className: 'toast-success',
    });
};

// Error toast (red)
export const showError = (message) => {
    toast.error(message, {
        ...toastConfig,
        className: 'toast-error',
    });
};

// Warning toast (orange/yellow)
export const showWarning = (message) => {
    toast.warning(message, {
        ...toastConfig,
        className: 'toast-warning',
    });
};

// Info toast (blue)
export const showInfo = (message) => {
    toast.info(message, {
        ...toastConfig,
        className: 'toast-info',
    });
};

// Custom toast with options
export const showToast = (message, type = 'info', options = {}) => {
    const config = { ...toastConfig, ...options };

    switch (type) {
        case 'success':
            toast.success(message, config);
            break;
        case 'error':
            toast.error(message, config);
            break;
        case 'warning':
            toast.warning(message, config);
            break;
        case 'info':
        default:
            toast.info(message, config);
            break;
    }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    success: showSuccess,
    error: showError,
    warning: showWarning,
    info: showInfo,
    custom: showToast
};
